import React from "react"
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import TableLoadingShell from '../table-loading-shell'
import '@sass/components/_table.scss'
import Moment from "moment"
import {overrideTableStyle} from '../../../utils'

const TableHeaderItems = [
  '',
  'CITY ID',
  'CITY NAME',
  'PREDICTION ID',
  'PREDICTION NAME',
  'STATUS'
]

const styles = [
  { width: '38px' },
  { width: '120px' },
  { width: '120px' },
  { width: '120px' },
  { width: '120px' },
  { width: '120px' }
]

class ViewMappedCity extends React.Component {

  constructor() {
    super()

    this.handleRowClick = this.handleRowClick.bind(this)
  }

  componentDidMount() {
    this.overrideTableStyle()
  }

  overrideTableStyle() {
    // document.querySelectorAll(".bordered--table")[1].parentElement.style.overflow = "auto"
    overrideTableStyle()
  }

  handleRowClick(rowIdx, colIdx) {
    this.props.history.push(`/home/manage-city-mapping/edit/${this.props.cityMappedtoPreditionList[rowIdx].prediction_id}`, this.props.cityMappedtoPreditionList[rowIdx])
  }

  render() {
    const {
      loadingCityMappedToPredictionList,
      cityMappedtoPreditionList
    } = this.props
    return (
      <div>
        <Table
          wrapperStyle={{ height: 'auto' }}
          className="bordered--table clickable"
          selectable={false}
          fixedHeader
          onCellClick={this.handleRowClick}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              {
                TableHeaderItems.map((item, i) => <TableHeaderColumn style={styles[i]} key={`table-head-col-${i}`}>{item}</TableHeaderColumn>)
              }
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
            showRowHover
          >
            {
              !loadingCityMappedToPredictionList && cityMappedtoPreditionList.length === 0 && 
              <tr>
                <td style={{ textAlign: 'center' }} colSpan='4'>
                  <p style={{fontWeight: '16px'}}>No cities found</p>
                </td>
              </tr>
            }
            {
              !loadingCityMappedToPredictionList
                ? (
                  cityMappedtoPreditionList.map((item, i) => {
                    return (
                      <TableRow key={i}>
                        <TableRowColumn style={styles[0]}>
                          <button
                            //onClick={e => this.handleRowClick(e, item)}
                          >
                            Edit
                          </button>
                        </TableRowColumn>
                        <TableRowColumn style={styles[1]}>{item.city_id}</TableRowColumn>
                        <TableRowColumn style={styles[2]}>{item.CityName}</TableRowColumn>
                        <TableRowColumn style={styles[3]}>{item.prediction_id}</TableRowColumn>
                        <TableRowColumn style={styles[4]}>{item.prediction_title}</TableRowColumn>
                        <TableRowColumn style={styles[4]}>{item.status}</TableRowColumn>
                      </TableRow> 
                    )
                  })
                )
                : (
                  [1, 2, 3, 4, 5].map(() => (
                    <TableLoadingShell />
                  ))
                )
            }
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default ViewMappedCity
